
          import { defineNuxtPlugin } from "#imports";

          export default defineNuxtPlugin({
            name: 'sentry-client-config',
            async setup() {
              await import("/codebuild/output/src3681227186/src/ClientWebNuxt/sentry.client.config.ts")
            }
          });